(function() {
    'use strict';

    FileDirectDownloadController.$inject = [
        '$routeParams',
        'fileDownloadService'
    ];

    function FileDirectDownloadController($routeParams, fileDownloadService) {
        var vm = this;

        vm.fileId = $routeParams.fileId;

        vm.directDownload = directDownload;

        function directDownload(fileId) {
            fileDownloadService.download(fileId);
        }

        if (vm.fileId) {
            vm.directDownload(vm.fileId);
        }
    }

    module.exports = FileDirectDownloadController;
})();